<template>
  <div>
    <slot
      :readFunc="handleReadCard"
      :reading="reading"
    ></slot>
  </div>
</template>

<script>
import WebSocketReadCard from './WebSocketReadCard'
import { mapState } from 'vuex'

export default {
  name: 'WebSocketReadCard',
  components: {},
  props: {
    // 1：身份证；2：IC 卡
    readMode: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      // webSocket: new WebSocket('ws://127.0.0.1:30004/ws')
      webSocket: null,

      reading: false,
      hideReadingTips: null
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  deactivated() {
    this.closeWebSocket()
  },
  destroyed() {
    this.closeWebSocket()
  },
  methods: {
    // 读卡
    handleReadCard() {
      if (this.reading) return;
      this.reading = true

      // webSocket 不存在，则创建 webSocket 连接
      !this.webSocket && (this.webSocket = new WebSocket('ws://127.0.0.1:30004/ws'))

      // webSocket 传输至服务器的数据
      const sendMsg = this.readMode === 1 ? null : this.createSocketSendMsg_ICCard()

      // 读卡时的信息提示
      const readingTips = this.readMode === 1
        ? this.$t('wsReadCard.readingIDCard')
        : this.$t('wsReadCard.readingICCard')

      this.hideReadingTips = this.$message.loading(readingTips, 0);

      WebSocketReadCard(
        this.webSocket,
        sendMsg,
        this.readSuccessCallback,
        this.readFailCallback
      )
    },

    // 读卡成功回调
    readSuccessCallback(res) {
      this.closeReadingStatus()
      this.closeWebSocket()

      const successTips = this.readMode === 1
        ? this.$t('wsReadCard.readIDCardSuccess')
        : this.$t('wsReadCard.readICCardSuccess')
      this.$message.success(successTips, 2.5);

      this.$emit('readSuccess', res)
    },

    // 读卡失败回调
    readFailCallback(err) {
      this.closeReadingStatus()
      this.closeWebSocket()

      //  WebSocket连接已经关闭或者连接不能打开
      if (err.state === 3) {
        this.$warning({
          title: this.$t('wsReadCard.readCardWarning'),
          content: this.getRenderOfWebSocketFail(),
          width: this.lang === 'zh_CN' ? '' : 570,
          okText: this.$t('wsReadCard.closeBtn')
        });
        return
      }
      // 其他读卡错误
      const errTips = this.readMode === 1
        ? this.$t('wsReadCard.readIDCardFail')
        : this.$t('wsReadCard.readICCardFail')
      this.$notification.error({
        message: errTips,
        description: err.message,
        duration: 3
      });
    },
    // 获取读 IC 时 webSocket 传输至服务器的数据；WebSocketReadCard 里默认是读身份证的数据
    createSocketSendMsg_ICCard() {
      const szJson = '{"Cmd":30400,"Head":"YZWL","IPFlag":"YWYyNWMxOWQ1ZTY4ZmJhOQ==","UserParam":"","Version":"V1.0.0"}\n';
      return szJson
    },

    closeWebSocket() {
      this.webSocket && this.webSocket.close();
      this.webSocket = null;
    },
    closeReadingStatus() {
      this.hideReadingTips && setTimeout(this.hideReadingTips, 0)
      this.reading = false
    },

    // 返回 WebSocket 打开失败的提示内容，render 函数形式
    getRenderOfWebSocketFail() {
      const h = this.$createElement;

      return h('div', {}, [
        h('p',
          {
            style: { color: '#F5222D' }
          },
          this.$t('wsReadCard.webSocketTip')
        ),
        h('p', '1. ' + this.$t('wsReadCard.webSocketTip1')),
        h('p', {}, [
          '2. ' + this.$t('wsReadCard.webSocketTip2'),
          h('a',
            {
              class: 'text-primary',
              attrs: {
                href: 'http://d.yzfuture.cn/p/14',
                target: '_blank'
                // href: process.env.BASE_URL + 'yzwlReadCardServer.exe',
                // download: 'yzwlReadCardServer.exe'
              }
            },
            this.$t('wsReadCard.downloadReadExe')
          )
        ])
      ])
    }
  }
}
</script>

<style>
</style>
